export default function TermosAssinatura({ aceito, onChange }) {
  return (
    <div className="p-4 bg-slate-50 border border-slate-200 rounded-2xl space-y-3 text-xs text-slate-500 leading-relaxed">
      <p className="font-black text-slate-700 text-[11px] uppercase tracking-wider">
        Termos da Cobrança
      </p>

      <ul className="space-y-1.5 list-none">
        <li>
          • Esta é uma <strong>cobrança única</strong> no cartão informado. Não
          há cobrança recorrente nem renovação automática.
        </li>
        <li>
          • Seu acesso vale por 1 mês a partir de hoje. Para seguir no mês
          seguinte, é preciso contratar de novo — nossa equipe entra em contato
          para renovar.
        </li>
        <li>
          • Como não existe cobrança recorrente, não é preciso cancelar nada: a
          vigência termina sozinha ao fim do mês.
        </li>
        <li>• Não há reembolso proporcional após a cobrança.</li>
        <li>
          • Seus dados de cartão são processados com segurança pelo Asaas e não
          são armazenados em nossos servidores.
        </li>
      </ul>

      <label className="flex items-start gap-3 cursor-pointer pt-1 border-t border-slate-200">
        <input
          type="checkbox"
          checked={aceito}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 w-4 h-4 accent-[#ff2d6c] cursor-pointer flex-shrink-0"
        />
        <span className="font-semibold text-slate-700">
          Li e concordo com os termos acima e autorizo esta cobrança única.
        </span>
      </label>
    </div>
  );
}
